import React from "react";
import { Button, Drawer, Form, Input, InputNumber, Select, Spin } from "antd";
import { FacilityList, FacilityPost } from "../models/facility";
import {Role, UserContext} from "../controller/Utils";

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;


class FacilityFilterForm extends React.Component {
  static contextType = UserContext;
  state = {
    visible: false,
    data: [],
    value: [],
    fetching: false
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };
  fetchFacility = (value = '') => {
    this.setState({ data: [], fetching: true });
    const requestData = {'search': value};
    FacilityList(requestData)
      .then(body => {
        const data = body.data.results.map(facility => ({
          text: `${facility.name}`,
          value: facility.id
        }));
        this.setState({data, fetching: false });
      });
  };
  handleChange = value => {
    this.setState({
      value,
      fetching: false
    });
    this.props.onChange(value.key);
  };

  handleDrawerSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        FacilityPost(values)
          .then(response => {
            this.setState({
              visible: false,
              value: { key: response.id, label: response.name }
            });
            this.props.onChange(response.id);
          });
      }
    });
  };


  defaultFacility = () => {
    FacilityList({'ordering': 'id'})
      .then(response => {
        if (response.data.results.length) {
          const first_row = response.data.results[0];
          this.handleChange({key: first_row.id, label: first_row.name})
        }
      })
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this);
    if(!this.props.is_update)
      this.defaultFacility()
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {fetching, data, value} = this.state;
    const {getFieldDecorator} = this.props.form;
    return (
      <div className="pos-relative">
        <Select labelInValue showSearch value={value} placeholder="Select Facility"
          notFoundContent={fetching ? <Spin size="small" /> : "Not Found"} filterOption={false}
          onSearch={this.fetchFacility} onFocus={this.fetchFacility} onChange={this.handleChange}
          style={{ width: "100%" }}>
          {data.map(d => (<Option key={d.value}>{d.text}</Option>))}
        </Select>
        <Role allow={["admin"]} user={this.context.user}>
        <Button className="plus-btn-pop " type="primary" onClick={this.showDrawer}>
          <i className="fa fa-plus" />
        </Button>
        </Role>
        <div>
          <Drawer title="Add Facility" placement="right" onClose={this.onClose} visible={this.state.visible}
            className="floating-form" destroyOnClose={true}>
            <Form>
              <FormItem label="Facility Name">
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Please input name' }],
                })(<Input placeholder="Enter facility name" />)}
              </FormItem>
              <FormItem label="Address">
                {getFieldDecorator('address', {
                  rules: [{ required: true, message: 'Please input address' }],
                })(<TextArea placeholder="Enter facility address" autosize={{ minRows: 4 }} />)}
              </FormItem>
              <FormItem label="City">
                {getFieldDecorator('city', {
                  rules: [{ required: true, message: 'Please input city' }],
                })(<Input placeholder="Enter facility city" />)}
              </FormItem>
              <FormItem label="Zip Code">
                {getFieldDecorator('zip_code', {
                  rules: [{ required: true, message: 'Please input zip code' }],
                })(<InputNumber min={1} placeholder="Enter facility zip code" size="100%" />,)}
              </FormItem>
              <FormItem label="EPA ID">
                {getFieldDecorator('epa_id')(<Input placeholder="Enter EPA ID" />)}
              </FormItem>
              <Button type="primary" htmlType="button" onClick={this.handleDrawerSubmit}>Add Facility</Button>
            </Form>
          </Drawer>
        </div>
      </div>
    );
  }
}

export const FacilityFilter = Form.create()(FacilityFilterForm);


// WEBPACK FOOTER //
// ./src/filters/Facility.jsx